export const MAX_NAME_LENGTH = 255;
export const MAX_COMPANY_NAME_LENGTH = 170;
export const MAX_JOB_TITLE_LENGTH = 255;

// server-side limits (from the Account Registration API doc) — used for error-message interpolation
export const SERVER_MAX_USER_NAME_LENGTH = 50;
export const SERVER_MAX_EMAIL_LENGTH = 100;
export const SERVER_MAX_PASSWORD_LENGTH = 255;

// shared by the registration schema (client validation) and the server-error parser
export const PASSWORD_MIN_LENGTH = 12;

// contact-sales link target for the signup-blocked banner (see TQCT-1753 / TQCT-1652)
export const CONTACT_SALES_URL = "https://www.smartling.com/meeting-request/";
